/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import SaveButton from 'material/ctas/save/save';
import CTAs from 'material/ctas/ctas';
import Button from "material/ctas/button/button_container";
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reportcontrols/variations/preview/previewCTAs_styles';




/* ========== ~~~~~~~~~~ CTA : EDIT INFO  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class PreviewCTAs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            save: false
        };
    }
    componentDidUpdate(prevProps) {
        if(!this.props.currentPage && prevProps.currentPage) { this.resetState(); }
    }
    downloadExcel = () => {
        this.props.downloadExcel();
    };
    downloadCSV = () => {
        this.props.downloadCSV();
    };
    handleSave = () => {
        this.setState({ save: true });
        this.props.handleSave();
    };
    render() {
        return (
            <div className={`previewCTAs ${this.props.classes.previewCTAs}`}>
                <CTAs name={'editdownload'} >
                    <Button variant={'primary'} type={'internal'} text={'Edit'} action={'dashboard/reports/detail'} disabled={this.props.saveReportPending} />
                    <Button variant={'secondary'} type={'action'} text={'Download Excel'} handleClick={this.downloadExcel} operation={'download'} processing={this.props.reportDownloading.includes('XLSX')} removeLoaderIcon={true} disabled={this.props.saveReportPending} />
                    <Button variant={'secondary'} type={'action'} text={'Download CSV'} handleClick={this.downloadCSV} operation={'download'} processing={this.props.reportDownloading.includes('CSV')} removeLoaderIcon={true} disabled={this.props.saveReportPending} />
                </CTAs>
                <CTAs name={'exitsave'} >
                    <Button variant={'system'} type={'internal'} text={'Exit'} action={'dashboard/reports'} disabled={this.props.saveReportPending} />
                    <SaveButton
                        variant={'action'}
                        handleSave={this.handleSave}
                        savingData={this.props.saveReportPending}
                        buttonText={this.props.isReportSaved && !this.state.saveandrun ? 'Saved' : null}
                        disabled={this.props.isReportSaved || this.props.saveReportPending}
                    />
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PreviewCTAs);
